<template>
    <div class="kid-common-address">
        <header class="kid-common-address__title">请填写收货地址</header>
        <main class="kid-common-address__content">
            <div class="kid-common-address__item">
                <span class="kid-common-address__item--title">联系人</span>
                <input type="text" class="kid-common-address__item--content" placeholder="请填写收货人姓名" v-model="addressee">
            </div>
            <div class="kid-common-address__item">
                <span class="kid-common-address__item--title">手机号</span>
                <input type="text" class="kid-common-address__item--content" placeholder="请填写收货手机号码" v-model="realMobile">
            </div>
            <div class="kid-common-address__item">
                <span class="kid-common-address__item--title">所在地区</span>
                <input type="text" @click="getAreaDic" readonly="readonly" v-model="area" class="kid-common-address__item--content " placeholder="请选择收货人所在地区">
            </div>
            <div class="kid-common-address__item">
                <span class="kid-common-address__item--title">收货地址</span>
                <input type="text" class="kid-common-address__item--content" placeholder="请填写收货详细地址" v-model="address">
            </div>
        </main>
        <p class="kid-common-address__warn">请务必填写正确收货地址，购买后将于7个工作日内完成发货</p>
        <button class="kid-common-address__submit" @click="saveAddress">保存</button>
    </div>
</template>

<script>
    import api from '@/api'
    import { rsaEncrypt, aesEncrypt, aesDecrypt } from '@/utils/encryption'
    import Toast from '@/base/toast/toast'
    import areaSelector from '@/components/multilevel_linkage'
    import { formatAddress } from '@/components/multilevel_linkage/utils'
    export default {
        name: "Address",
        data () {
            return {
                addressee: '',
                realMobile: '',
                address: '',
                NAME_REG: new RegExp(/^([\u4e00-\u9fa5]|[a-zA-Z]| |·|-|●|(\（+\）)|(\（[\u4e00-\u9fa5]+\）)|(\（[a-zA-Z]+\）))+$/),
                MOBILE_REG: new RegExp(/^1[3456789]\d{9}$/),
                areaDicData: [],
                isGettingAreaData: false,
                area: '',
                areaSelectorInstance: null,
                municipalityInfo: '北京,上海,天津,重庆', // 直辖市集合
            }
        },
        watch:{
            'areaSelectorInstance.exportData'(newVal) {
                if (!newVal) return;
                this.formatCurrentAddress(newVal);
            },
        },
        methods: {
            formatCurrentAddress(newVal) {
                newVal['isDistrictDicEmpty'] = !newVal.district;
                const exportData = formatAddress(newVal);
                if (!exportData) return;
                const {exportProvince, exportCity, exportDistrict, area} = exportData;
                this.area = area;
                this.city = exportCity || '';
                this.province = exportProvince;
                this.district = exportDistrict || '';
            },
            verifyData() {
                let message = null;
                switch(true) {
                    case !this.addressee:
                        message = '请填写收货人信息';
                        break;
                    case !this.NAME_REG.test(this.addressee):
                        message = '收货人姓名不能包数字和含特殊字符';
                        break;
                    case !this.realMobile:
                        message = '请填写手机号码';
                        break;
                    case !this.MOBILE_REG.test(this.realMobile):
                        message = '手机号码有误';
                        break;
                    case !this.address:
                        message = '请填写详细地址';
                        break;
                }
                message && Toast(message);
                return !message;
            },
            formatData() {
                const data = {
                    address: this.address,
                    addressee: this.addressee,
                    city: this.city,
                    defaulted: this.defaulted,
                    district: this.district,
                    id: null,
                    mobile: this.realMobile,
                    province: this.province,
                    realMobile: this.realMobile,
                };
                return JSON.stringify(data);
            },
            async saveAddress() {
                if (!this.verifyData()) { return; }
                const {encrypted, key, iv, parseKey, parseIv} = aesEncrypt(this.formatData());
                const json_data = rsaEncrypt(JSON.stringify({k: key, iv}));
                try {
                    const { data } = await api.addAddress(json_data, encrypted);
                    let info;
                    if (typeof data === 'string') {
                        info = aesDecrypt(data, parseKey, parseIv);
                    } else {
                        info = data;
                    }
                    const {code, message } = info;
                    if (code * 1 === 0) {
                        Toast({message: '地址保存成功', duration:1500, icon: 'success'});
                        this.submitAdData();
                    } else {
                        Toast({message, duration: 1500});
                    }
                } catch (e) {
                    Toast({message: "地址保存失败，请重试", duration: 1500});
                }
            },
            async getAreaDic() {
                if (this.isGettingAreaData) {
                    return;
                }
                const areaData = localStorage.getItem('areaDic');
                if (areaData) {
                    this.areaDicData = JSON.parse(areaData);
                    this.areaSelectorInstance = areaSelector(this.areaDicData);
                    return;
                }
                if (!this.areaSelectorInstance && this.areaDicData.length) {
                    this.areaSelectorInstance = areaSelector(this.areaDicData);
                    return;
                }
                this.isGettingAreaData = true;
                try {
                    const { data: {code, message, data} } = await api.getAreaDic();
                    if (code * 1 !== 0) {
                        return Toast(message);
                    }
                    this.areaDicData = data;
                    localStorage.setItem('areaDic', JSON.stringify(data));
                    this.areaSelectorInstance = areaSelector(this.areaDicData);
                    setTimeout(
                        () => {
                            this.isGettingAreaData = false;
                        }, 400
                    )
                } catch (e) {
                    this.isGettingAreaData = false;
                    Toast('数据请求失败，请重试！');
                    console.error(e);
                }
            },

        }
    }
</script>

<style scoped lang="scss">
.kid-common-address {
    width: px2rem(750);
    border-top: px2rem(15) solid #F6F6F6;
    &__title {
        padding: px2rem(28) 0 px2rem(28) px2rem(42);
        font-size: px2rem(32);
        font-weight: 500;
        color: #454545;
        line-height: px2rem(41);
        text-align: left;
        background-color: #fff;
    ;
    }
    &__content {
        padding: px2rem(20) 0;
        background-color: #fff;
        border-bottom: px2rem(1) solid #E0E0E0;
        border-top: px2rem(1) solid #E0E0E0;
    }
    &__item {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: px2rem(20) px2rem(49) px2rem(20) px2rem(39);
        height: px2rem(110);
        box-sizing: border-box;
        &--title {
            display: flex;
            align-items: center;
            justify-content: center;
            width: px2rem(125);
            height: 100%;
            margin-right: px2rem(12);
            background: linear-gradient(93deg, #FDE43E 0%, #FED017 100%);
            border-radius: px2rem(30);
            font-size: px2rem(25);
            font-weight: bold;
            color: #85440B;
            line-height: 0;
        }
        &--content {
            height: 100%;
            padding: 0 px2rem(20);
            background: #FFFFFF;
            border: px2rem(3) solid #FFC11A;
            border-radius: px2rem(29);
            flex-grow: 1;
            font-size: px2rem(27);
        }
    }
    &__warn {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: px2rem(27) 0;
        font-size: px2rem(22);
        font-weight: bold;
        color: #FE7317;
        line-height: px2rem(41);
        background-color: #fff;
        &::before {
            content: '';
            width: px2rem(33);
            height: px2rem(33);
            margin-right: px2rem(12);
            background: url("./images/icon_warn.png") center center no-repeat;
            background-size: 100%;
        }
    }
    &__submit {
        margin: px2rem(35) 0 ;
        width: px2rem(652);
        height: px2rem(87);
        background: #FE7317;
        border-radius: px2rem(19);
        border:none;
        font-size: px2rem(40);
        font-weight: bold;
        color: #FFFFFF;
    }
}
</style>